const hashCode = (str) => {
  /* eslint-disable */
  if (Array.prototype.reduce) {
    return str.split('').reduce((a, b) => {
      a = ((a << 5) - a) + b.charCodeAt(0);
      return a & a;
    }, 0);
  }

  let hash = 0;

  if (str.length === 0) {
    return hash;
  }

  for (let i = 0; i < str.length; i++) {
    const character = str.charCodeAt(i);

    hash = ((hash << 5) - hash) + character;
    hash = hash & hash; // Convert to 32bit integer
  }

  return hash;
  /* eslint-enable */
};

const getPathName = () => {
  if (window.location.pathname) {
    const paths = window.location.pathname.split('/');

    if (paths.length) {
      if (paths.length > 1) {
        return `/${paths[1]}`;
      }

      return `/${paths[0]}` || '/';
    }
  }

  return '/';
};

const isIEBrowser = () => {
  const ua = window.navigator.userAgent;

  return /Edge\/|Trident\/|MSIE/.test(ua);
};

const getQueryStringParam = (key) => {
  const valores = [];
  const url = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');

  for (let i = 0; i < url.length; i += 1) {
    const arrParamInfo = url[i].split('=');

    if (arrParamInfo[0] === key || arrParamInfo[0] === `${key}[]`) {
      valores.push(decodeURIComponent(arrParamInfo[1]));
    }
  }

  if (valores.length > 0) {
    return valores.length === 1 ? valores[0] : valores;
  }

  return null;
};

export default {};
export {
  hashCode,
  getPathName,
  isIEBrowser,
  getQueryStringParam,
};
